module.exports = __webpack_public_path__ + "img/au-service-des-pharmaciens.1d7697d5.jpg";